const API_BASE = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '')

export function assetUrl(url) {
  if (!url) return url

  if (/^https?:\/\//i.test(url)) return url
  return `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}`
}
